import { setPbrAnisotropy } from '../material/pbr/set-anisotropy.js';

const ext = {
  id: "KHR_materials_anisotropy",
  async applyMaterial(mat, ctx) {
    const a = mat._rawMatDef?.extensions?.KHR_materials_anisotropy;
    if (!a) {
      return null;
    }
    const rot = a.anisotropyRotation ?? 0;
    const texture = a.anisotropyTexture ? await ctx._texture(a.anisotropyTexture, false) : void 0;
    const out = {};
    setPbrAnisotropy(out, {
      isEnabled: true,
      intensity: a.anisotropyStrength ?? 0,
      direction: [Math.cos(rot), Math.sin(rot)],
      texture
    });
    return out;
  }
};

export { ext as default };
//# sourceMappingURL=gltf-ext-anisotropy.js.map
